import AddIcon from '@mui/icons-material/Add'
import { Paper } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'
import React from 'react'

import { Alert } from '../../Alert'
import { ButtonIcon, ButtonSecondary } from '../../Button'
import { DataTree } from '../../DataTree'
import { FlexLayout } from '../../Layout'
// eslint-disable-next-line unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars
import { CatalogData, CatalogDataItem, CatalogLabels } from './definitions'
import { DeleteDialog } from './DeleteDialog'
import { EditButton } from './EditButton'
import { EditDialog } from './EditDialog'
import { useCatalog } from './hooks/useCatalog'

type Props = {
  /** A tree of {@link CatalogDataItem} */
  data: CatalogData
  /** An object representation of the labels in the component */
  labels: CatalogLabels
}

/**
 *
 * @param {Props} props {@link Props.data} accepts a {@link CatalogData}, a tree of {@link CatalogDataItem} and {@link Props.labels} accepts a {@link CatalogLabels}, an object representation of the labels in the component
 * @returns A {@link DataTree} view constructed starting from the data passed as prop to the component
 */
export const Catalog = (props: Props) => {
  const { data, labels } = props

  const catalog = useCatalog(data)

  const columns: GridColDef[] = [
    {
      field: 'description',
      headerName: labels.secondaryColumn,
      sortable: false,
      disableColumnMenu: true,
      flex: 3,
    },
    {
      field: '',
      headerName: '',
      sortable: false,
      type: 'actions',
      getActions: (params) => {
        return [<EditButton key={crypto.randomUUID()} catalog={catalog} params={params} />]
      },
      flex: 1,
    },
  ]

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleAddItem = () => catalog.openEditDialog()

  const opts = catalog.getNodesLabel()

  return (
    <>
      <FlexLayout>
        <Paper elevation={0}>
          <ButtonSecondary data-test-id={`catalog-add-item-${labels.topic}`} onClick={handleAddItem}>
            <ButtonIcon>
              <AddIcon />
            </ButtonIcon>
            {`Add ${labels.topic}`}
          </ButtonSecondary>
        </Paper>
        <DataTree
          data-test-id="catalog"
          apiRef={catalog.apiRef}
          columns={columns}
          groupingColDef={{ headerName: labels.mainColumn, flex: 2 }}
          getTreeDataPath={(row) => row.path.split('/')}
          rows={catalog.nodes}
          rowSelection={false}
          treeData
          isGroupExpandedByDefault={catalog.isGroupExpanded}
          hideFooter
        />
        {catalog.editDialogState.open && <EditDialog options={opts} catalog={catalog} labels={labels} />}
        {catalog.deleteDialogState.open && <DeleteDialog catalog={catalog} labels={labels} />}
      </FlexLayout>
      <Alert
        data-test-id="catalog-alert"
        isShowing={catalog.alertState.visible}
        onClose={catalog.closeAlert}
        alertMessage={catalog.alertState.message}
      />
    </>
  )
}
